import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';

class SubseasonAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			subSeason: {},
			divisions: [],
			teamDiv: [],
			newDivName: '',
			msgSaved: '',
		};
	
		this.loadData = this.loadData.bind(this);
		this.getSubSeason = this.getSubSeason.bind(this);
		this.getDivisions = this.getDivisions.bind(this);
		this.getTeamDiv = this.getTeamDiv.bind(this);
		this.divisionsTable = this.divisionsTable.bind(this);
		this.handleSubSeasonNameChange = this.handleSubSeasonNameChange.bind(this);
		this.handleSubSeasonStartDateChange = this.handleSubSeasonStartDateChange.bind(this);
		this.handleSubseasonTypeFinalsChange = this.handleSubseasonTypeFinalsChange.bind(this);

		this.createDivRow = this.createDivRow.bind(this);
		this.handleDelDiv = this.handleDelDiv.bind(this);
		this.handleNewDivision = this.handleNewDivision.bind(this);
		this.handleNewDivChange = this.handleNewDivChange.bind(this);
		this.createTeamDivRow = this.createTeamDivRow.bind(this);
		this.handleDivChange = this.handleDivChange.bind(this);
		this.handleSaveClick = this.handleSaveClick.bind(this);

		this.savedMsgSet = this.savedMsgSet.bind(this);
		this.savedMsgUnset = this.savedMsgUnset.bind(this);
	}

 	componentDidMount() {
		// console.log('SubseasonAdmin: componentDidMount');
		this.loadData(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('SubseasonAdmin: UNSAFE_componentWillReceiveProps');
		this.loadData(nextProps);
	}

	loadData(props) {
		var subSeason = {};
		var divisions = [];
		var teamDiv = [];

    var _this = this;
    if (props.season._id !== undefined) {
	    Axios.get('/api/teams/season/' + props.season._id).then(function (response) {

      	var teams = response.data;
				_this.getSubSeason(props.season, subSeason);
				_this.getDivisions(subSeason, divisions);
				_this.getTeamDiv(teams, subSeason, teamDiv);

				console.log('subSeason')
				console.log(subSeason)

				console.log('divisions')
				console.log(divisions)

				console.log('teamDiv')
				console.log(teamDiv)

        _this.setState({
					subSeason: subSeason,
					divisions: divisions,
					teamDiv: teamDiv,
        });
      });
   	}
	}

	getSubSeason(season, subSeason) {

		// console.log('SubseasonAdmin: getSubSeason');
		var _this = this;
		var subSeasons = season.subSeasons;

		/* Get subSeason info from season */
		if (subSeasons) {
			subSeasons.forEach(function (subSeasonItem) {
				if(subSeasonItem.id === _this.props.ssid) {

					// copy object properties
					for (var attrname in subSeasonItem) { 
						subSeason[attrname] = subSeasonItem[attrname];
					}

      		var startDate = subSeasonItem.startDate;
      		if ((startDate === null) || (startDate === '')) {
	        	var todaysDate = new Date();
	        	startDate = todaysDate;
	        }
					subSeason.startDate = moment(startDate).utc().format("YYYY-MM-DD");
				}
      });
		}
	}

	getDivisions(subSeason, divisions) {
		// console.log('SubseasonAdmin: getDivisions');
		if (subSeason.divisions) {
			for (var idx = 0; idx < subSeason.divisions.length; idx++) {
				divisions[idx] = subSeason.divisions[idx];
			}
		}
	}

	getTeamDiv(teams, subSeason, teamDiv) {
		// console.log('SubseasonAdmin: getTeamDiv: ');
    var _this = this;
		var seasonDoc = [];
		var subSeasonItem = {};
		var divisionsArray = [];
		
		/* Get subSeason info from season */
		if (teams) {

			// Parse teams array and build teamDiv array
			teams.forEach(function (teamItem) {

				var teamDivItem = {};
				if(subSeason.divisions.length > 0) {
					// [2022-11-21] NO DIVISION OPTION
					teamDivItem.div = "NO DIV"; 	// subSeason.divisions[0].name;	// default to first item
				} else {
					teamDivItem.div = "";	// empty
				}

				// then look if it's included in a division, and set it
				subSeason.divisions.forEach(function (divItem, divIdx, divArray) {

					teamDivItem._id = teamItem._id;
					teamDivItem.name = teamItem.name;

					// check if team exists in div
					if(divItem.teams.indexOf(teamItem._id) !== -1) {
						teamDivItem.div = divItem.name;
					}
				});

				teamDiv.push(teamDivItem);
			});
		}
	}

  render() {
		//console.log('SubSeasonAdmin: RENDER');
		//console.log(this.state.season._id);
		//console.log("divisions")
		//console.log(this.state.divisions)
		//console.log("teamDiv")
		//console.log(this.state.teamDiv)

    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

		return (
			<div className="row">
			<div className="col-md-12">

        {/* React component header*/}
				<h5><b>Sous-saison:&nbsp;&nbsp;</b>{this.state.subSeason.name} [{this.props.ssid}]</h5>
				<Link to='/admsafe/season/subs' className="btn btn-primary"> Retour à la Saison </Link>
				<br/><br/>

				<div className="row">
				<div className="col-md-6">
					<div className="card">
						<div className="card-header">
						<i className="fa fa-th-large"></i>
							Paramètres généraux
						</div>

						<div className="card-block">
					
							<div className="row">
							<div className="col-md-12">
							Nom de la sous-saison
							<input type="text" className="form-control" id="subSeasonName" value={this.state.subSeason.name || ''} 
								placeholder="" onChange={this.handleSubSeasonNameChange} />
		 					</div>
		 					</div>
							<br/>

							<div className="row">
							<div className="col-md-8">
							Date de départ
							<input type="date" className="form-control" id="subSeasonStartDate" 
								value={this.state.subSeason.startDate || defaultDate} 
								placeholder="" onChange={this.handleSubSeasonStartDateChange} />
		 					</div>
		 					</div>

							<br/>
							<div className="row">
							<div className="col-md-8">
								<label className="switch switch-3d switch-success form-control-label">
								<input type="checkbox" className="switch-input form-check-input" 
									checked={this.state.subSeason.typeFinals || false} onChange={this.handleSubseasonTypeFinalsChange}/>
								<span className="switch-label"></span>
								<span className="switch-handle"></span>
								</label>
								&nbsp;&nbsp;Finales de ligue (pas de points de ronde)
		 					</div>
		 					</div>

	 					</div>
 					</div>
 				</div>
 				</div>

				<div className="row">
				<div className="col-md-6">

					<div className="card">
						<div className="card-header">
						<i className="fa fa-th-large"></i>
							Liste des Divisions
						</div>
						<div className="card-block">
	 						{this.divisionsTable()}

					  	Ajouter une nouvelle division <br/>
	 					<input type="text" className="form-control" id="divName" placeholder="Nom de la division" 
							value={this.state.newDivName || ''} onChange={this.handleNewDivChange}/>
							<br/>
						<button type="button" className="btn btn-primary" 
							onClick={this.handleNewDivision}>Ajouter la division</button>

		 				</div>
		 			</div>
 				</div>

 				<div className="col-md-6">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						Liste des Équipes
					</div>
					<div className="card-block">
						<table className="table table-striped table-hover table-sm">
						<tbody>
        		<tr>
							<th>Équipes</th>
							<th>Division</th>
           	</tr>
          	{this.state.teamDiv.map(this.createTeamDivRow)}
						</tbody>
            </table>
					</div>
				</div>
 				</div>
 				</div>

				<button type="submit" className="btn btn-primary" onClick={this.handleSaveClick}>
					Sauvegarder la sous-saison</button>
				<br/><br/>
				{this.state.msgSaved}
				<br/>
      </div>
      </div>
    );
  }

	handleSubSeasonNameChange(e) {
		var subSeason = this.state.subSeason;
		subSeason.name = e.target.value;
		this.setState({subSeason: subSeason});
	}

	handleSubSeasonStartDateChange(e) {
		var subSeason = this.state.subSeason;
		subSeason.startDate	= e.target.value;
		this.setState({subSeason: subSeason});
	}

	handleSubseasonTypeFinalsChange(e) {
		var subSeason = this.state.subSeason;
		subSeason.typeFinals = e.target.checked;
		this.setState({subSeason: subSeason});
	}

  // Test pour avoir du contenu conditionnel en gérant les exigences des tags
  // ex: <i> ne peut pas être à l'intérieur d'une <table> ou de <tbody>
  divisionsTable() {

		if (this.state.divisions.length === 0) {
  		return (
				<div>
					<i>Aucune division enregistrée</i>
				</div>
			);
  	} else {
  		return (
 				<table className="table table-striped table-hover table-sm">
  			<tbody>
          <tr>
						<th>Divisions</th>
						<th></th>
          </tr>
  				{this.state.divisions.map(this.createDivRow)}
				</tbody>
				</table>
			);
  	}
 	}

  createDivRow(divItem, divIdx) {
		return (
			<tr key={'div.' + divIdx}>
				<td>{divItem.name}</td>
  	    <td className="text-right">
        	<input id={'DelDiv.' + divIdx} type="button" onClick={this.handleDelDiv} value="X"/>
        </td>
      </tr>
    );
  }

	handleDelDiv(e) {
		var dIdx = e.target.id.split(".")[1];
		var divisions = this.state.divisions;
		divisions.splice(dIdx, 1);
		this.setState({divisions: divisions});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

  handleNewDivision(e) {
  	var divisions = this.state.divisions;
  	var teamDiv = this.state.teamDiv;
  	var newDivName = this.state.newDivName;
  	var bSameDivName = false;

  	// check if this division name already exists 
  	divisions.forEach(function (divItem) {
  		if(newDivName === divItem.name) {
			bSameDivName = true;
  		}
  	});
    	
  	if(bSameDivName) { 
			alert('Nom de division existant');
  		return; 
  	}

		divisions.push({
			name: newDivName,
			teams: []
		});

		// if no division was present, set all teams divisions to this one
		if(divisions.length === 1) {
			teamDiv.forEach(function (teamDivItem) {
				teamDivItem.div = newDivName;
			});
		}

		this.setState({
			newDivName: '', 
			divisions: divisions,
			teamDiv: teamDiv
		});

		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleNewDivChange(e) {
		this.setState({
			newDivName: e.target.value,
		});
	}

  createTeamDivRow(teamDivItem, teamDivIdx) {
		return (
			<tr key={'te.' + teamDivIdx}>
				<td>{teamDivItem.name}</td>
				<td>
	        <select className="form-control" id={"divSelect." + teamDivIdx} 
        		value={teamDivItem.div} onChange={this.handleDivChange}>

        		{/* [2022-11-21] NO DIVISION OPTION */}
			      <option value="NO DIV" key='div.NODIV'>AUCUNE DIVISION</option>
            {this.state.divisions.map(this.createSelectDivItem)}
	        </select>
				</td>
      </tr>
    );
  }

  createSelectDivItem(divItem, divIdx) {
    return (
      <option value={divItem.name} key={'div.' + divIdx}>{divItem.name}</option>
    );
  }

	handleDivChange(e) {
		var tIdx = e.target.id.split(".")[1];
		var teamDiv = this.state.teamDiv;

		teamDiv[tIdx].div = e.target.value;
		this.setState({teamDiv: teamDiv});

		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleSaveClick() {
		var _this = this;
		var divisions = this.state.divisions;

		// build divisions objects
		divisions.forEach(function (divItem, divIdx, divArr) {

			divItem.teams.splice(0, divItem.teams.length)		// emptying array
			_this.state.teamDiv.forEach(function (teamDivItem, teamDivIdx) {

				if(divItem.name === teamDivItem.div) {
					divItem.teams.push(teamDivItem._id);
				}
			})
		})

		// Post to DB
		Axios.post('/api/seasons/subSeason/update', {
			seasonObjId: _this.props.season._id,
			subSeasonId: String(_this.props.ssid),
			subSeasonName: this.state.subSeason.name,
			startDate: this.state.subSeason.startDate,
			divisions: divisions,
			typeFinals: this.state.subSeason.typeFinals
		})
		.then(function(response) {
			//console.log(response);
			_this.props.reloadSeason();
		})
		.catch(function(error) {
			console.log(error);
		});

		this.savedMsgSet();
 	}

  savedMsgSet() {
		this.setState({ msgSaved: "Saison sauvegardée !" });
  }

  savedMsgUnset(msgStr) {
		this.setState({ msgSaved: msgStr });
  }

}

export default SubseasonAdmin;